import * as React from "react";
import { IconProps } from "./IconProps";

export const IconPuzzle = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 3.13037C9.89543 3.13037 9 4.0258 9 5.13037V7.13037H5V9.16132C6.97316 9.40737 8.5 11.0906 8.5 13.1304C8.5 15.1702 6.97316 16.8534 5 17.0994V19.1304H7.03095C7.277 17.1572 8.96019 15.6304 11 15.6304C13.0398 15.6304 14.723 17.1572 14.9691 19.1304H17V15.1304H19C20.1046 15.1304 21 14.2349 21 13.1304C21 12.0258 20.1046 11.1304 19 11.1304H17V7.13037H13V5.13037C13 4.0258 12.1046 3.13037 11 3.13037ZM7 5.13037C7 2.92123 8.79086 1.13037 11 1.13037C13.2091 1.13037 15 2.92123 15 5.13037H18C18.5523 5.13037 19 5.57809 19 6.13037V9.13037C21.2091 9.13037 23 10.9212 23 13.1304C23 15.3395 21.2091 17.1304 19 17.1304V20.1304C19 20.6827 18.5523 21.1304 18 21.1304H14C13.4477 21.1304 13 20.6827 13 20.1304V19.6304C13 18.5258 12.1046 17.6304 11 17.6304C9.89543 17.6304 9 18.5258 9 19.6304V20.1304C9 20.6827 8.55228 21.1304 8 21.1304H4C3.44772 21.1304 3 20.6827 3 20.1304V16.1304C3 15.5781 3.44772 15.1304 4 15.1304H4.5C5.60457 15.1304 6.5 14.2349 6.5 13.1304C6.5 12.0258 5.60457 11.1304 4.5 11.1304H4C3.44772 11.1304 3 10.6827 3 10.1304V6.13037C3 5.57809 3.44772 5.13037 4 5.13037H7Z"
          fill={color}
        />
      </svg>
    );
  },
);
